import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Provider } from 'jotai';
import Modal from 'react-modal';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './atoms';

Modal.setAppElement('#root');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);

const excludeList = ['Warning: findDOMNode is deprecated and will be removed',
  "Warning: %s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.%s"];
// const excludeList = [];
const initialConsoleError = console.error;
console.error = (...args) => {
  if (args?.length) {
    // eslint-disable-next-line no-restricted-syntax
    for (const arg of args) {
      // eslint-disable-next-line no-restricted-syntax
      for (const excludeItem of excludeList) {
        if (typeof arg?.startsWith === 'function' && arg.startsWith(excludeItem)) return;
      }
    }
  }
  initialConsoleError(...args);
};

reportWebVitals();
